import { z } from 'zod';
import { PHOTO_KINDS } from './enums.js';
/**
 * Фотографии рабочего места.
 *
 * Главный риск проекта: слабый мобильный интернет. Отсюда все решения ниже —
 * жать на клиенте, отправлять кусками, докачивать после обрыва и никогда
 * не заставлять оператора ждать загрузку.
 */
/** Максимум по длинной стороне после сжатия. */
export const PHOTO_MAX_SIDE_PX = 1600;
/** Качество JPEG при сжатии на клиенте. */
export const PHOTO_JPEG_QUALITY = 0.7;
/** Ориентир по размеру файла после сжатия. */
export const PHOTO_TARGET_BYTES = 300_000;
/** Предохранитель: файлы крупнее сервер не принимает. */
export const PHOTO_MAX_BYTES = 5 * 1024 * 1024;
/** Размер куска при порционной загрузке. */
export const PHOTO_CHUNK_SIZE = 256 * 1024;
/** Сколько живёт подписанная ссылка на фото. */
export const PHOTO_LINK_TTL_SECONDS = 10 * 60;
/** Сколько хранятся сами файлы. Метаданные остаются навсегда. */
export const PHOTO_RETENTION_DAYS = 180;
export function chunkCount(bytes, chunkSize = PHOTO_CHUNK_SIZE) {
    return Math.max(1, Math.ceil(bytes / chunkSize));
}
export const photoInitSchema = z.object({
    /** UUID, сгенерированный на устройстве вместе со снимком. */
    id: z.string().uuid(),
    /** id отчёта, к которому относится фото. Отчёт может ещё не доехать до сервера. */
    reportId: z.string().uuid(),
    siteId: z.string().uuid(),
    machineId: z.string().uuid().nullish(),
    shiftNumber: z.number().int().min(1).max(3),
    /** Что на снимке: продукция или переданное рабочее место. */
    kind: z.enum(PHOTO_KINDS).default('WORKPLACE'),
    /** Время съёмки на устройстве. */
    takenAt: z.string().datetime({ offset: true }),
    bytes: z.number().int().positive().max(PHOTO_MAX_BYTES),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    /** SHA-256 сжатого файла — по нему сервер проверит, что собрал ровно то, что снимали. */
    sha256: z.string().regex(/^[0-9a-f]{64}$/, 'Ожидается SHA-256 в шестнадцатеричном виде'),
    chunkSize: z.number().int().positive().max(PHOTO_CHUNK_SIZE),
});
/** Статус фото у смены в отчёте администратора. */
export const PHOTO_REPORT_STATUS_LABEL = {
    NONE: 'не прикреплено',
    PENDING: 'ожидает загрузки',
    UPLOADED: 'загружено',
};
//# sourceMappingURL=photos.js.map